import React, { Component } from 'react';

import { MAX_ATTACHMENT_SIZE_IN_BYTES } from 'constants/attachments';
import { formatBytes } from 'utilities/bytes';

import DragAndDropImg from 'img/illustrations/drag-and-drop.svg';

import './styles.less';

class UploadAttachmentForm extends Component {
  render() {
    const { error } = this.props;

    return (
      <div className="upload-attachment-form">
        <img src={DragAndDropImg} className="thumb-drag-and-drop-illo" />
        <p>
          Drag and drop or{' '}
          <span onClick={this.handleUploadSelect}>choose file</span>
        </p>
        <p
          className={`upload-attachment-recommendation ${error ? 'error' : ''}`}
        >
          {error
            ? error
            : `We recommend files under ${formatBytes(
                MAX_ATTACHMENT_SIZE_IN_BYTES
              )}{' '} with the extension .doc, .key, .pages, .zip, .pdf, or .jpg.`}
        </p>
        <input
          type="file"
          id="upload-attachment-file"
          onClick={this.handleUploadInputClick}
          onChange={this.props.onSelection}
          multiple
        />
      </div>
    );
  }

  handleUploadInputClick = event => {
    event.stopPropagation();
  };

  handleUploadSelect = () => {
    document.querySelector('#upload-attachment-file').click();
  };
}

export default UploadAttachmentForm;
